import CrudPage from "@/components/CrudPage";
import { useAuth, canWrite } from "@/context/AuthContext";
import { num } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

export default function EmissionFactor() {
  const { user } = useAuth();
  const writeRoles = ["environmental_officer"];
  return (
    <CrudPage
      title="Master Faktor Emisi"
      subtitle="Faktor emisi karbon per sumber & aktivitas."
      endpoint="/emission-factors"
      canWrite={canWrite(user?.role, writeRoles)}
      searchKeys={["code", "sumber", "jenis_aktivitas"]}
      columns={[
        { key: "code", label: "Kode" },
        { key: "sumber", label: "Sumber Emisi" },
        { key: "jenis_aktivitas", label: "Aktivitas" },
        { key: "faktor_emisi", label: "Faktor", align: "right", render: (r) => `${num(r.faktor_emisi, 4)} ${r.satuan_emisi || "kg CO₂e"}/${r.satuan_aktivitas}` },
        { key: "boundary", label: "Boundary" },
        { key: "wilayah", label: "Wilayah" },
        { key: "tahun", label: "Tahun" },
        { key: "referensi", label: "Sumber/Referensi" },
        { key: "status_verifikasi", label: "Verifikasi", render: (r) => <Badge className={r.status_verifikasi === "terverifikasi" ? "bg-green-100 text-green-800 border-green-200 border" : "bg-amber-100 text-amber-800 border-amber-200 border"}>{r.status_verifikasi === "terverifikasi" ? "Terverifikasi" : "Belum"}</Badge> },
      ]}
      fields={[
        { key: "code", label: "Kode Faktor" },
        { key: "sumber", label: "Sumber Emisi" },
        { key: "jenis_aktivitas", label: "Jenis Aktivitas" },
        { key: "satuan_aktivitas", label: "Satuan Aktivitas" },
        { key: "satuan_emisi", label: "Satuan Emisi", defaultValue: "kg CO2e" },
        { key: "faktor_emisi", label: "Faktor Emisi", type: "number", step: "0.0001" },
        { key: "boundary", label: "Boundary / Batas Sistem", type: "select", defaultValue: "gate-to-gate", options: [
          { value: "gate-to-gate", label: "Gate-to-gate" }, { value: "cradle-to-gate", label: "Cradle-to-gate" },
          { value: "A1-A3", label: "A1–A3" }, { value: "A1-A4", label: "A1–A4" }, { value: "khusus", label: "Boundary Khusus" }] },
        { key: "wilayah", label: "Wilayah" },
        { key: "tahun", label: "Tahun", type: "number" },
        { key: "metode", label: "Metode" },
        { key: "referensi", label: "Referensi / Sumber", full: true },
        { key: "sumber_url", label: "URL / Dokumen", full: true },
        { key: "tingkat_kualitas", label: "Tingkat Kualitas", type: "select", defaultValue: "sedang", options: [
          { value: "tinggi", label: "Tinggi" }, { value: "sedang", label: "Sedang" }, { value: "rendah", label: "Rendah" }] },
        { key: "status_verifikasi", label: "Status Verifikasi", type: "select", defaultValue: "belum_terverifikasi", options: [
          { value: "terverifikasi", label: "Terverifikasi" }, { value: "belum_terverifikasi", label: "Belum Terverifikasi" }] },
        { key: "status", label: "Status", type: "select", defaultValue: "aktif", options: [{ value: "aktif", label: "Aktif" }, { value: "nonaktif", label: "Nonaktif" }] },
      ]}
    />
  );
}
